export { default } from './BadgeModalContent';
